import { msg } from 'gt-react';
import { ArrowsLeftRightIcon } from '@phosphor-icons/react';
import { ProductModule } from '@erp/shared-types';
import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import {
  Route as pathlessAuthenticatedRoute,
  requireAdmin,
  requireModules,
} from '../route';

const OrderfulTransactionsPage = lazyRouteComponent(
  () => import('./OrderfulTransactionsPage'),
);

export const Route = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/orderful-transactions',
  staticData: {
    app: {
      nav: {
        label: msg('Transactions', {
          context: 'sidebar nav label, Sales section',
        }),
        icon: <ArrowsLeftRightIcon className="h-4 w-4" weight="fill" />,
        group: 'Sales',
        order: 59,
      },
      access: {
        adminOnly: true,
        modulesAllOf: [
          ProductModule.ORDERFUL_EDI,
          ProductModule.FAMOUS_INTEGRATION,
        ],
      },
    },
  },
  component: OrderfulTransactionsPage,
  loader: () => ({
    crumb: msg('Transactions', { context: 'page breadcrumb' }),
  }),
  beforeLoad: ({ context }) => {
    requireAdmin({ context });
    requireModules({
      context,
      allOf: [ProductModule.ORDERFUL_EDI, ProductModule.FAMOUS_INTEGRATION],
    });
  },
});
